export default "__VITE_ASSET__0b515977__"